<div class="d-flex">
    <div class="ml-auto">
        <div class="cit2-badge-status">
            <div class="gb-body-1 gb-align-center" attr.aria-label="{{productTag}}"><p class="mb-0">{{productTag}}</p></div>   
        </div>
    </div>
</div>